
/**
 * @export
 * @type ProductSeatUpdateItem
 */
export type ProductSeatUpdateItem = {
    userId: number;
    userEmail: string;
    productAccessTermId: string;
    productName: string;
    externalSubscriptionId: string;
    startDate?: string;
    endDate?: string;
    errors?: Array<string>;
    actionStatus: ProductSeatUpdateItemActionStatus;
}

export enum ProductSeatUpdateItemActionStatus {
    PENDING = 'PENDING',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    CANCELED = 'CANCELED'
}